import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { AppRoute } from './Route'

/**
 * Settings pages moved under new menu groups. Old paths keep working (emails, bookmarks, docs) by
 * redirecting to the new ones.
 */
const LEGACY_SETTINGS_PATHS: { from: string; to: string }[] = [
  { from: '/settings/company/general', to: '/settings/company/company-info/general' },
  { from: '/settings/company/appearance', to: '/settings/company/company-info/appearance' },
  { from: '/settings/company/users', to: '/settings/company/company-info/users' },
  { from: '/settings/company/fiscal-years', to: '/settings/company/financial/fiscal-years' },
  { from: '/settings/company/personnel', to: '/settings/company/financial/personnel' },
  { from: '/settings/company/dimensions', to: '/settings/company/financial/dimensions' },
  { from: '/settings/company/accounts', to: '/settings/company/financial/accounts' },
  { from: '/settings/company/account-map', to: '/settings/company/financial/account-map' },
  { from: '/settings/company/reallocation', to: '/settings/company/financial/reallocation' },
  { from: '/settings/company/subscriptions', to: '/settings/company/report-distribution/company-dashboard' },
  {
    from: '/settings/company/subscriptions/company-dashboard',
    to: '/settings/company/report-distribution/company-dashboard'
  },
  {
    from: '/settings/company/subscriptions/custom-reports',
    to: '/settings/company/report-distribution/custom-reports'
  },
  {
    from: '/settings/company/subscriptions/accountor-scorecard',
    to: '/settings/company/report-distribution/accountor-scorecard'
  },
  {
    from: '/settings/company/subscriptions/kiinteistomaailma-scorecard',
    to: '/settings/company/report-distribution/kiinteistomaailma-scorecard'
  }
]

const LegacyRedirect: React.FC<{ to: string }> = ({ to }) => {
  const { search, hash } = useLocation()
  return <Navigate to={`${to}${search}${hash}`} replace />
}

export const legacySettingsRedirectRoutes: AppRoute[] = LEGACY_SETTINGS_PATHS.map(({ from, to }) => ({
  path: from,
  hideInMenu: true,
  element: <LegacyRedirect to={to} />
}))
